export class Mappable {
  [x: string]: any;
  fromJSON(json) {
    Object.keys(json).map(key => this[key] = json[key] );
    return this;
  }
}
